/**
 * Nav-tabs module
 *
 * Initialises Bootstrap's Tab component for every .b-nav-tabs block.
 * Importing the Tab class alone is sufficient for click handling; calling
 * getOrCreateInstance() also registers the keyboard handler (arrow-key
 * navigation) required by the WAI-ARIA Tabs Pattern and WCAG 2.1/2.2.
 */
import Tab from "bootstrap/js/dist/tab";

export function initTabs() {
    const tabButtons = document.querySelectorAll('.b-nav-tabs [role="tab"]');

    if (!tabButtons.length) return;

    tabButtons.forEach((el) => {
        Tab.getOrCreateInstance(el);
    });

    /**
     * Sync tabindex on panels after Bootstrap switches tabs.
     * The active panel must be reachable via Tab key (tabindex="0");
     * inactive panels must not be in the tab sequence (tabindex="-1").
     */
    document.querySelectorAll(".b-nav-tabs").forEach((block) => {
        block.addEventListener("shown.bs.tab", (e) => {
            const targetId = e.target.getAttribute("aria-controls");
            block.querySelectorAll('[role="tabpanel"]').forEach((panel) => {
                panel.tabIndex = panel.id === targetId ? 0 : -1;
            });
        });
    });
}
